import { LinkComponent, createLink } from '@tanstack/react-router'
import { forwardRef } from 'react'

import BottomNavigationAction, {
    BottomNavigationActionProps,
} from '@mui/material/BottomNavigationAction'
import Button, { ButtonProps } from '@mui/material/Button'
import CardActionArea, { CardActionAreaProps } from '@mui/material/CardActionArea'
import Link, { LinkProps } from '@mui/material/Link'
import ListItem, { ListItemProps } from '@mui/material/ListItem'
import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton'
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem'
import Tab, { TabProps } from '@mui/material/Tab'

type LinkRouterProps = LinkProps

const LinkRouterComponent = forwardRef<HTMLAnchorElement, LinkRouterProps>((props, ref) => (
    <Link ref={ref} {...props} />
))

LinkRouterComponent.displayName = 'LinkRouterComponent'

const CreatedLink = createLink(LinkRouterComponent)

export const RouterLink: LinkComponent<typeof LinkRouterComponent> = (props) => (
    <CreatedLink {...props} />
)

type TabRouterProps = TabProps<'a'>

const TabRouterComponent = forwardRef<HTMLAnchorElement, TabRouterProps>((props, ref) => (
    <Tab ref={ref} component="a" nativeButton={false} {...props} />
))

TabRouterComponent.displayName = 'TabRouterComponent'

const CreatedTab = createLink(TabRouterComponent)

export const RouterTab: LinkComponent<typeof TabRouterComponent> = (props) => (
    <CreatedTab {...props} />
)

type ListItemRouterProps = ListItemProps<'a'>

const ListItemRouterComponent = forwardRef<HTMLAnchorElement, ListItemRouterProps>((props, ref) => (
    <ListItem ref={ref} component="a" {...props} />
))

ListItemRouterComponent.displayName = 'ListItemRouterComponent'

const CreatedListItem = createLink(ListItemRouterComponent)

export const RouterListItem: LinkComponent<typeof ListItemRouterComponent> = (props) => (
    <CreatedListItem {...props} />
)

type ListItemButtonRouterProps = ListItemButtonProps<'a'>

const ListItemButtonRouterComponent = forwardRef<HTMLAnchorElement, ListItemButtonRouterProps>(
    (props, ref) => <ListItemButton ref={ref} component="a" {...props} />,
)

ListItemButtonRouterComponent.displayName = 'ListItemButtonRouterComponent'

const CreatedListItemButton = createLink(ListItemButtonRouterComponent)

export const RouterListItemButton: LinkComponent<typeof ListItemButtonRouterComponent> = (
    props,
) => <CreatedListItemButton {...props} />

type MenuItemRouterProps = MenuItemProps<'a'>

const MenuItemRouterComponent = forwardRef<HTMLAnchorElement, MenuItemRouterProps>((props, ref) => (
    <MenuItem ref={ref} component="a" {...props} />
))

MenuItemRouterComponent.displayName = 'MenuItemRouterComponent'

const CreatedMenuItem = createLink(MenuItemRouterComponent)

export const RouterMenuItem: LinkComponent<typeof MenuItemRouterComponent> = (props) => (
    <CreatedMenuItem {...props} />
)

type CardActionAreaRouterProps = CardActionAreaProps<'a'>

const CardActionAreaRouterComponent = forwardRef<HTMLAnchorElement, CardActionAreaRouterProps>(
    (props, ref) => <CardActionArea ref={ref} component="a" {...props} />,
)

CardActionAreaRouterComponent.displayName = 'CardActionAreaRouterComponent'

const CreatedCardActionArea = createLink(CardActionAreaRouterComponent)

export const RouterCardActionArea: LinkComponent<typeof CardActionAreaRouterComponent> = (
    props,
) => <CreatedCardActionArea {...props} />

type BottomNavigationActionRouterProps = BottomNavigationActionProps<'a'>

const BottomNavigationActionRouterComponent = forwardRef<
    HTMLAnchorElement,
    BottomNavigationActionRouterProps
>((props, ref) => <BottomNavigationAction ref={ref} component="a" {...props} />)

BottomNavigationActionRouterComponent.displayName = 'BottomNavigationActionRouterComponent'

const CreatedBottomNavigationAction = createLink(BottomNavigationActionRouterComponent)

export const RouterBottomNavigationAction: LinkComponent<
    typeof BottomNavigationActionRouterComponent
> = (props) => <CreatedBottomNavigationAction {...props} />

type ButtonRouterProps = ButtonProps<'a'>

const ButtonRouterComponent = forwardRef<HTMLAnchorElement, ButtonRouterProps>((props, ref) => (
    <Button ref={ref} component="a" {...props} />
))

ButtonRouterComponent.displayName = 'ButtonRouterComponent'

const CreatedButton = createLink(ButtonRouterComponent)

export const RouterButton: LinkComponent<typeof ButtonRouterComponent> = (props) => (
    <CreatedButton {...props} />
)
